import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/main.css'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import { applyTheme } from './utils/themeUtils'

// 开发环境下挂载测试工具
if (process.env.NODE_ENV === 'development') {
  import('./utils/testRecommendations').then(module => {
    window.testRecommendations = module.default
    console.log('%c🎯 测试工具已加载', 'color: #10b981; font-size: 14px; font-weight: bold')
    console.log('%c使用方法：', 'color: #6366f1; font-weight: bold')
    console.log('  window.testRecommendations.testSingleCode("RIA")')
    console.log('  window.testRecommendations.testBatchGenerate()')
    console.log('  window.testRecommendations.compareECR()')
  })
}

const app = createApp(App)

// 应用主题
applyTheme()

// Toast配置
app.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
})

app.use(router).mount('#app')
